var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZoomIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.35,
    d: "M8.94295 8.94265C10.0616 7.82399 11.649 6.23665 12.6576 5.22799L13.6623 6.23265C14.0256 6.59599 14.647 6.33999 14.6496 5.82665L14.667 2.17332C14.669 1.70865 14.2916 1.33132 13.827 1.33332L10.1736 1.35065C9.65962 1.35332 9.40428 1.97465 9.76762 2.33799L10.7723 3.34265C9.76362 4.35132 8.17628 5.93865 7.05762 7.05732L8.94295 8.94265Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.05702 7.05731C5.93835 8.17598 4.35102 9.76331 3.34235 10.772L2.33768 9.76731C1.97435 9.40398 1.35302 9.65998 1.35035 10.1733L1.33302 13.8266C1.33102 14.2913 1.70835 14.6686 2.17302 14.6666L5.82635 14.6493C6.34035 14.6466 6.59568 14.0253 6.23235 13.662L5.22768 12.6573C6.23635 11.6486 7.82368 10.0613 8.94235 8.94264L7.05702 7.05731Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIcon);
export default __webpack_public_path__ + "static/media/ZoomIcon.bb4601f630a7f249bf216d788cd7daf6.svg";
export { ForwardRef as ReactComponent };